<template>
  <div v-if="value">
    <v-row>
      <v-col cols="12">
        <v-select
          :items="[{value:'mr',text:'Monsieur'},{value:'mme', text:'Madame'}]"
          placeholder="Titre"
          hide-details="auto"
          v-model="value.title"
          :rules="[mandatoryRules]"
          class="title"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="value.lastname"
          label="Nom"
          :hide-details="true"
          :rules="[mandatoryRules]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="value.firstname"
          label="Prénom"
          :hide-details="true"
          :rules="[mandatoryRules]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="value.email"
          label="Email"
          :hide-details="true"
          :rules="[mandatoryRules]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="value.phone"
          label="Téléphone"
          :hide-details="true"
          :rules="[mandatoryRules]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-select
          :items="[{text:'Utilisateur',value:'user'},{text:'Manager', value:'manager'}]"
          label="Role"
          v-model="value.role"
          :hide-details="true"
          :rules="[mandatoryRules]"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    mandatoryRules: v => !!v || "Ce champ est obligatoire"
  }),
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  watch: {
    value: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>